import { z } from 'zod';
import * as formSystem from '@/shared/form-system/schema';
import {
  queryPatientResSchema,
  specialStatusDtoSchema,
} from '~/generated/sdrs/zod-schema';

const laborStageItemSchema = queryPatientResSchema.shape.laborStage.unwrap();

const specialConditionItemSchema =
  specialStatusDtoSchema.shape.patientSpecialCondition.unwrap();

export const abnormalConditionItemSchema = specialConditionItemSchema.exclude([
  'NORMAL',
]);

export type LaborStage = z.infer<typeof laborStageItemSchema>;
export type SpecialCondition = z.infer<typeof specialConditionItemSchema>;
export type AbnormalCondition = z.infer<typeof abnormalConditionItemSchema>;

export const laborStageSchema = z
  .array(laborStageItemSchema)
  .optional()
  .catch(undefined);

export const specialConditionSchema = z
  .array(specialConditionItemSchema)
  .optional()
  .catch(undefined);

export const deliveryRoomSearchParamsSchema = z.object({
  doctorCode: z.string().optional(),
  laborStage: laborStageSchema,
  specialCondition: specialConditionSchema,
});

export type DeliveryRoomSearchParams = z.infer<
  typeof deliveryRoomSearchParamsSchema
>;

export const assessmentFormsSearchSchema = z
  .object({
    keyword: z.string().optional().default(''),
    showCancelled: z.boolean().optional().default(false),
    runtimeId: z.string().optional(),
    rowType: z.lazy(() => formSystem.runtimeRowTypeSchema).optional(),
    templateId: z.string().optional(),
  })
  .refine((data) => !(data.templateId && data.runtimeId), {
    message: 'templateId and runtimeId are mutually exclusive',
  })
  .refine((data) => !data.runtimeId || !!data.rowType, {
    message: 'runtimeId requires rowType',
  });
